import moment from 'moment';

export const getLastNDaysIncludingToday = (numberDays:number): { startDate: string, endDate: string } => {
  const endDate = moment().format('DD/MM/YYYY'); // Día actual
  const startDate = moment().subtract(numberDays, 'days').format('DD/MM/YYYY'); // Fecha hace numberDays días

  return { startDate, endDate };
}
